import { render, staticRenderFns } from "./ChatLog.vue?vue&type=template&id=58165f84&scoped=true"
import script from "./ChatLog.vue?vue&type=script&lang=js"
export * from "./ChatLog.vue?vue&type=script&lang=js"
import style0 from "./ChatLog.vue?vue&type=style&index=0&id=58165f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58165f84",
  null
  
)

export default component.exports